// ABOUTME: Custom TipTap extension for font weights matching Text component.
// ABOUTME: Weights: black (1000), bold (700), semibold (500), normal (400).

import { Extension } from "@tiptap/core";

export const FONT_WEIGHTS = {
    black: "1000",
    bold: "700",
    semibold: "500",
    normal: "400",
};

const FontWeight = Extension.create({
    name: "fontWeight",

    addOptions() {
        return {
            types: ["textStyle"],
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontWeight: {
                        default: null,
                        parseHTML: (element) => element.style.fontWeight || null,
                        renderHTML: (attributes) => {
                            if (!attributes.fontWeight || attributes.fontWeight === "normal") return {};
                            const weight = FONT_WEIGHTS[attributes.fontWeight] || attributes.fontWeight;
                            return { style: `font-weight: ${weight}` };
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontWeight: (weight) => ({ chain }) => chain().setMark("textStyle", { fontWeight: weight }).run(),
            unsetFontWeight: () => ({ chain }) => chain().setMark("textStyle", { fontWeight: null }).removeEmptyTextStyle().run(),
        };
    },
});

export default FontWeight;
